import VueRouter from 'vue-router'
//引入组件
import Index from '../pages'
import Home from '../pages/home/home'
import Login from '../pages/login/login'
import Register from '../pages/register/register'
import Center from '../pages/center/center'
import Storeup from '../pages/storeup/list'
import News from '../pages/news/news-list'
import NewsDetail from '../pages/news/news-detail'
import payList from '../pages/pay'

import siyangyuanList from '../pages/siyangyuan/list'
import siyangyuanDetail from '../pages/siyangyuan/detail'
import siyangyuanAdd from '../pages/siyangyuan/add'
import zhushexinxiList from '../pages/zhushexinxi/list'
import zhushexinxiDetail from '../pages/zhushexinxi/detail'
import zhushexinxiAdd from '../pages/zhushexinxi/add'
import huanjingjianceList from '../pages/huanjingjiance/list'
import huanjingjianceDetail from '../pages/huanjingjiance/detail'
import huanjingjianceAdd from '../pages/huanjingjiance/add'
import siliaoleixingList from '../pages/siliaoleixing/list'
import siliaoleixingDetail from '../pages/siliaoleixing/detail'
import siliaoleixingAdd from '../pages/siliaoleixing/add'
import siliaoxinxiList from '../pages/siliaoxinxi/list'
import siliaoxinxiDetail from '../pages/siliaoxinxi/detail'
import siliaoxinxiAdd from '../pages/siliaoxinxi/add'
import zhongleiList from '../pages/zhonglei/list'
import zhongleiDetail from '../pages/zhonglei/detail'
import zhongleiAdd from '../pages/zhonglei/add'
import shengzhuxinxiList from '../pages/shengzhuxinxi/list'
import shengzhuxinxiDetail from '../pages/shengzhuxinxi/detail'
import shengzhuxinxiAdd from '../pages/shengzhuxinxi/add'
import siyangjihuaList from '../pages/siyangjihua/list'
import siyangjihuaDetail from '../pages/siyangjihua/detail'
import siyangjihuaAdd from '../pages/siyangjihua/add'
import touweixinxiList from '../pages/touweixinxi/list'
import touweixinxiDetail from '../pages/touweixinxi/detail'
import touweixinxiAdd from '../pages/touweixinxi/add'
import fangyijihuaList from '../pages/fangyijihua/list'
import fangyijihuaDetail from '../pages/fangyijihua/detail'
import fangyijihuaAdd from '../pages/fangyijihua/add'
import yimiaozhongleiList from '../pages/yimiaozhonglei/list'
import yimiaozhongleiDetail from '../pages/yimiaozhonglei/detail'
import yimiaozhongleiAdd from '../pages/yimiaozhonglei/add'
import yimiaoxinxiList from '../pages/yimiaoxinxi/list'
import yimiaoxinxiDetail from '../pages/yimiaoxinxi/detail'
import yimiaoxinxiAdd from '../pages/yimiaoxinxi/add'
import yimiaojiezhongList from '../pages/yimiaojiezhong/list'
import yimiaojiezhongDetail from '../pages/yimiaojiezhong/detail'
import yimiaojiezhongAdd from '../pages/yimiaojiezhong/add'
import syslogList from '../pages/syslog/list'
import syslogDetail from '../pages/syslog/detail'
import syslogAdd from '../pages/syslog/add'
import newstypeList from '../pages/newstype/list'
import newstypeDetail from '../pages/newstype/detail'
import newstypeAdd from '../pages/newstype/add'
import aboutusList from '../pages/aboutus/list'
import aboutusDetail from '../pages/aboutus/detail'
import aboutusAdd from '../pages/aboutus/add'
import systemintroList from '../pages/systemintro/list'
import systemintroDetail from '../pages/systemintro/detail'
import systemintroAdd from '../pages/systemintro/add'
import discussfangyijihuaList from '../pages/discussfangyijihua/list'
import discussfangyijihuaDetail from '../pages/discussfangyijihua/detail'
import discussfangyijihuaAdd from '../pages/discussfangyijihua/add'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

//配置路由
export default new VueRouter({
	routes:[
		{
      path: '/',
      redirect: '/index/home'
    },
		{
			path: '/index',
			component: Index,
			children:[
				{
					path: 'home',
					component: Home
				},
				{
					path: 'center',
					component: Center,
				},
				{
					path: 'pay',
					component: payList,
				},
				{
					path: 'storeup',
					component: Storeup
				},
				{
					path: 'news',
					component: News
				},
				{
					path: 'newsDetail',
					component: NewsDetail
				},
				{
					path: 'siyangyuan',
					component: siyangyuanList
				},
				{
					path: 'siyangyuanDetail',
					component: siyangyuanDetail
				},
				{
					path: 'siyangyuanAdd',
					component: siyangyuanAdd
				},
				{
					path: 'zhushexinxi',
					component: zhushexinxiList
				},
				{
					path: 'zhushexinxiDetail',
					component: zhushexinxiDetail
				},
				{
					path: 'zhushexinxiAdd',
					component: zhushexinxiAdd
				},
				{
					path: 'huanjingjiance',
					component: huanjingjianceList
				},
				{
					path: 'huanjingjianceDetail',
					component: huanjingjianceDetail
				},
				{
					path: 'huanjingjianceAdd',
					component: huanjingjianceAdd
				},
				{
					path: 'siliaoleixing',
					component: siliaoleixingList
				},
				{
					path: 'siliaoleixingDetail',
					component: siliaoleixingDetail
				},
				{
					path: 'siliaoleixingAdd',
					component: siliaoleixingAdd
				},
				{
					path: 'siliaoxinxi',
					component: siliaoxinxiList
				},
				{
					path: 'siliaoxinxiDetail',
					component: siliaoxinxiDetail
				},
				{
					path: 'siliaoxinxiAdd',
					component: siliaoxinxiAdd
				},
				{
					path: 'zhonglei',
					component: zhongleiList
				},
				{
					path: 'zhongleiDetail',
					component: zhongleiDetail
				},
				{
					path: 'zhongleiAdd',
					component: zhongleiAdd
				},
				{
					path: 'shengzhuxinxi',
					component: shengzhuxinxiList
				},
				{
					path: 'shengzhuxinxiDetail',
					component: shengzhuxinxiDetail
				},
				{
					path: 'shengzhuxinxiAdd',
					component: shengzhuxinxiAdd
				},
				{
					path: 'siyangjihua',
					component: siyangjihuaList
				},
				{
					path: 'siyangjihuaDetail',
					component: siyangjihuaDetail
				},
				{
					path: 'siyangjihuaAdd',
					component: siyangjihuaAdd
				},
				{
					path: 'touweixinxi',
					component: touweixinxiList
				},
				{
					path: 'touweixinxiDetail',
					component: touweixinxiDetail
				},
				{
					path: 'touweixinxiAdd',
					component: touweixinxiAdd
				},
				{
					path: 'fangyijihua',
					component: fangyijihuaList
				},
				{
					path: 'fangyijihuaDetail',
					component: fangyijihuaDetail
				},
				{
					path: 'fangyijihuaAdd',
					component: fangyijihuaAdd
				},
				{
					path: 'yimiaozhonglei',
					component: yimiaozhongleiList
				},
				{
					path: 'yimiaozhongleiDetail',
					component: yimiaozhongleiDetail
				},
				{
					path: 'yimiaozhongleiAdd',
					component: yimiaozhongleiAdd
				},
				{
					path: 'yimiaoxinxi',
					component: yimiaoxinxiList
				},
				{
					path: 'yimiaoxinxiDetail',
					component: yimiaoxinxiDetail
				},
				{
					path: 'yimiaoxinxiAdd',
					component: yimiaoxinxiAdd
				},
				{
					path: 'yimiaojiezhong',
					component: yimiaojiezhongList
				},
				{
					path: 'yimiaojiezhongDetail',
					component: yimiaojiezhongDetail
				},
				{
					path: 'yimiaojiezhongAdd',
					component: yimiaojiezhongAdd
				},
				{
					path: 'syslog',
					component: syslogList
				},
				{
					path: 'syslogDetail',
					component: syslogDetail
				},
				{
					path: 'syslogAdd',
					component: syslogAdd
				},
				{
					path: 'newstype',
					component: newstypeList
				},
				{
					path: 'newstypeDetail',
					component: newstypeDetail
				},
				{
					path: 'newstypeAdd',
					component: newstypeAdd
				},
				{
					path: 'aboutus',
					component: aboutusList
				},
				{
					path: 'aboutusDetail',
					component: aboutusDetail
				},
				{
					path: 'aboutusAdd',
					component: aboutusAdd
				},
				{
					path: 'systemintro',
					component: systemintroList
				},
				{
					path: 'systemintroDetail',
					component: systemintroDetail
				},
				{
					path: 'systemintroAdd',
					component: systemintroAdd
				},
				{
					path: 'discussfangyijihua',
					component: discussfangyijihuaList
				},
				{
					path: 'discussfangyijihuaDetail',
					component: discussfangyijihuaDetail
				},
				{
					path: 'discussfangyijihuaAdd',
					component: discussfangyijihuaAdd
				},
			]
		},
		{
			path: '/login',
			component: Login
		},
		{
			path: '/register',
			component: Register
		},
	]
})
